const base64UrlToJson = (segment) => {
  const base64 = segment.replace(/-/g, "+").replace(/_/g, "/");
  const padded = base64.padEnd(base64.length + ((4 - (base64.length % 4)) % 4), "=");
  return JSON.parse(decodeURIComponent(escape(atob(padded))));
};

/**
 * Whether the recovery link's JWT says it already expired. Reads `exp` without verifying the
 * signature: only to tell the user early, api still decides. Unreadable tokens return false.
 * @param {string} securitySignature
 * @param {number} now - milliseconds since epoch
 * @returns {boolean}
 */
export const isSecuritySignatureExpired = (securitySignature, now = Date.now()) => {
  try {
    const { exp } = base64UrlToJson(securitySignature.split(".")[1]);
    return Number.isFinite(exp) && exp * 1000 <= now;
  } catch {
    return false;
  }
};
